<template>

  <div v-if="project" class="donationList" ref="donationList">
    <!-- Bild + Gesamtspenden -->
    <a v-if="!preview" href="https://www.globalsocial-network.org/" class="no-deco" target="_blank" rel="noreferrer"><img alt="Global Social network" src="/images/logo_GlobalSocial.png" class="donationIcon"></a>
    <RTProjectDonatorLimitSum v-if="hasLimit" :limit="limit" :project="project" :preview="preview" @click="previewData=false" :stream_id="stream_id"/>
    <RTProjectDonationSum v-else :project="project" :preview="preview" @click="previewData=false"/>
    <!-- Liste an Spendenoptionen-->

    <div v-if="!previewData && step<=1">
      <!-- Spende total -->
      <div v-if="show_total_donations" class="mb-2" style="line-height: 1.5em;padding-top: 1em;">
        Mit Euer Unterstützung konnten wir für dieses Herzensprojekt bereits <br><b>{{isFloat(totalDonation)?totalDonation.toFixed(2):totalDonation}} €</b> Spenden sammeln.
      </div>
      <h3  class="text-center mb-0">JETZT Direkt spenden an</h3>
      <p class="text-center">{{project.title}}<br><span v-if="hasLimit">und Zugang zur Multivisionsshow erhalten</span></p>
    </div>
    <div v-if="step==1 && !previewData" class="donationListBox p-1">
      <div v-for="(p,index) in project.package" :key="index" class="row pb-05" :name="'package'+index" >
        <div class="col-7 col-6-small text-left">{{p.name}} <div v-if="p.additional" class="donAdd">{{p.additional}}</div></div>
        <div class="col-2 col-2-small pl-0 pt-05">{{(isFloat(p.price))?p.price.toFixed(2):p.price}} €</div>
        <div class="col-3 col-4-small">
          <select v-model="packages[index]" @input="setDonation(index,$event)">
            <option v-for="(n,i) in (maxAmoung+1)" :key="i" :value="(n-1)">{{n-1}}</option>
          </select>
        </div>
      </div>
      <div v-if="project.package_free" class="mt-2">
        <h3>Wähle deine Unterstützung</h3>
        <p v-if="hasLimit" style="text-align:center">Daraufhin senden wir dir deinen Zugang zum Stream per E-Mail zu</p>
        <Slider v-model="packageFreeValue" :min="project.package_free.min" :max="project.package_free.max" @input="calculateFreeDonation"/><h2>{{packageFreeValue}} €</h2>
      </div>
      <!--
      <div v-if="!project.package || project.package.length<1">

      </div>
      -->
      <!-- Button: Jetzt unterstützen -->
      <div class="mt-1">
        <a title="Jetzt unterstützen" :class="{disabled:( totalPersonalDonation<=0 || isNaN(totalPersonalDonation))}" class="w-100 button gsn-donate-button primary icon solid fa-heart"  href="#" @click.prevent="setForward">{{btnDonateButton}}</a>
      </div>
    </div>

    <div v-if="!previewData && step==1 && project.package_additional" >
      <div class="package_additional" v-html="project.package_additional"></div>
    </div>

    <!-- 2. Seite Payment -->
    <div v-if="step==2" class="row">
      <h3 class="w-100 pb-1 pt-1">
        <i class="fa fa-heart"></i> Deine Unterstützung:  {{totalPersonalDonation.toFixed(2)}} €
      </h3>
      <div class="col-12 pb-05">
        <input type="text" name="name" id="form-name" v-model="name" placeholder="Vor- und Nachname">
      </div>
      <div class="col-12 pb-05">
        <input type="email" name="email_donate" v-model="email" placeholder="E-Mail">
      </div>
      <div v-if="needAdress" class="col-12 pb-05">
        <input type="text" name="adress_donate" v-model="adress" placeholder="Adresse">
      </div>
      <div v-if="needAdress" class="col-12 pb-05">
        <input type="text" name="city_donate" v-model="city" placeholder="PLZ und Stadt">
      </div>


      <div class="col-12 text-left">
        <div v-if="!emailRequired" class="col-6">
          <input type="checkbox" id="anonym-check" name="anonymcheck" v-model="anonymDonation">
          <label for="anonym-check">Anonym unterstützen</label>
        </div>
        <div v-if="enableReceiptOption" class="col-6">
          <input :disabled="emptyEmail" type="checkbox" id="quittung" name="quittung" v-model="spendenquittung">
          <label for="quittung">Spendenquittung anfordern</label>
        </div>
        <div v-if="enableStreamNameOption" class="col-6">
          <input type="checkbox" id="stream_name_public" name="stream_name_public" v-model="streamNamePublic">
          <label for="stream_name_public">Deine Spende im Stream mit Namen veröffentlichen</label>
        </div>
        <div v-if="streamNamePublic" class="col-12 pt-05">
          <input type="text" maxlength="20" name="stream_name" v-model="streamUserName" @keypress="filterInput($event)" placeholder="Name, Synonym, Unternehmen ...">
        </div>
      </div>
      <div class="col-12 text-left tiny-text">
        Mit dem Bezahlen akzeptieren Sie unsere <a href="/datenschutz" target="_blank">Datenschutzbestimmungen</a>.
      </div>
      <!--
      <div class="col-12">
        <input type="email" name="email_donateproof" v-model="email_proof" placeholder="E-Mail bestätigen">
      </div>
      -->
      <!-- Button: Weiter -->
      <div class="mt-1 w-100">
        <div class="col-12">
          <a title="Weiter" :class="{disabled:notValid}" class="w-100 button gsn-donate-button primary icon solid fa-heart"  href="#" @click.prevent="setForward">Weiter</a>
        </div>
        <div class="col-12">
          <a title="Zurück" class="button w-100 btnBack" href="#" @click.prevent="setBackward">Zurück</a>
        </div>
      </div>
    </div>

    <!-- 3. Seite Payment -->
    <div v-if="step==3">
      <h3 class="w-100 pb-1">
        <i class="fa fa-heart"></i> Deine Unterstützung:  {{totalPersonalDonation.toFixed(2)}} €
      </h3>
      <!-- Überweisung + paypal-->
      <Payments ref="payments" :project="project" :stream_id="getCheckedStream(stream_id)" :name="name" :anonym="anonymDonation" :email="email" :adress="completeAdress" :shipping="hasSelectedPackageWithShippingOption" :quittung="spendenquittung" :packageName="totalPersonalPackages" :price="totalPersonalDonation" :streamUserName="streamUserName" @donationSuccess="donationSuccess"/>
      <div class="col-12">
        <a title="Zurück" class="button w-100 btnBack" href="#" @click.prevent="setBackward">Zurück</a>
      </div>
    </div>
    <!-- Thanks -->
    <div v-if="step==4" class="pt-1">
      <img src="/images/heart.png" height="100">
      <h2>Ein riesen großes Dankeschön für deine Unterstützung.</h2>

      <!-- TODO wenn response code enthält -->
      <!-- wir haben dir den Zugangscode an xxx@xxx.de gesendet-->
      <h2 v-if="hasStreamAccessCode" style="padding-top: 2em;padding-bottom: 1em;">Dein Code lautet: {{streamAccess['code']}}</h2>
      <p v-if="hasStreamAccessCode" style="text-align: center;font-size: 1.5em;">Gebe diesen auf<br>
        <a style="font-size: 0.75em;color: rgb(121, 161, 75);" :href="streamAccess['link']" target="_blank">{{streamAccess['link']}}</a><br>ein, um zum Stream zu gelangen.
      </p>
    </div>
  </div>
</template>

<script>
import Payments from '@/components/Payments.vue'
import RTProjectDonationSum from '@/components/RTProjectDonationSum.vue'
import RTProjectDonatorLimitSum from '@/components/RTProjectDonatorLimitSum.vue'
import {projectBase} from '@/mixins/projectBase.js'
import {helper} from '@/mixins/helper.js'
import Slider from '@/components/Slider.vue'

export default {
  //TODO: liste - in json und von form nehmen
  /*
  package:[{name:'',price:10},{}]
  */
  name: 'RTDonateList',
  mixins:[projectBase,helper],
  components:{
    RTProjectDonationSum,
    RTProjectDonatorLimitSum,
    Payments,
    Slider
  },
  props:{
    project:{
      type:Object
    },
    preview:{
      type:Boolean,
      default:false
    },
    stream_id:{
      type:String
    },
    show_total_donations:{
      type:Boolean,
      default:true
    },
    enableStreamNameOption:{
      type:Boolean,
      default:true
    },
    emailRequired:{
      type:Boolean,
      default:false
    },
    limit:{
      type:Number,
      default:-1
    }
  },
  watch:{
    project:{
      handler(v) {
        if(v){
          this.initView();
        }
      },
      deep:true
      
    },
    
    preview(v){
      this.previewData=v;
    },
    anonymDonation(v){
      if(v){
        this.spendenquittung=(this.emptyEmail)?false:this.spendenquittung;
        this.email=(this.email.trim()!="")?this.email:"";
        this.name=(this.name.trim()!="")?this.name:"Anonym";
      }
    }
  },
  data: function() {
    return {
      initialized:false,
      previewData:this.preview,
      step:1,
      packages:[],
      packageFreeValue:0,
      maxAmoung:10,
      totalPersonalDonation:0,
      totalPersonalPackages:"",
      name:"",
      adress:"",
      city:"",
      streamUserName:"",
      email:"",
      email_proof:"",
      anonymDonation:false,
      spendenquittung:false,
      streamNamePublic:false,
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    };
  },
  computed:{

    hasStreamAccessCode(){
      return this.streamAccess && !this._.isEmpty(this.streamAccess['code'])
    },

    streamAccess(){
      return this.$store.getters['shops/getStreamAccess']();
    },

    hasLimit(){
      return this.limit>=0;
    },

    totalDonation(){
      let donations=(this.project)?this.getDonationsByProjectId(this.project.id):null;
      return (donations)?donations.sum:0;
    },

    completeAdress(){
      return this.adress+' '+this.city
    },

    invalidAdress(){
      return (this.adress.trim()=="" || this.city.trim()=="")
    },

    needAdress(){
      return this.hasSelectedPackageWithShippingOption || this.hasSelectedReceiptOption;
    },

    packagesWithShipping(){
      if(this.project){
        return this._.filter(this.project.package,(p,i)=>{
            return this.packages[i] && p.shipping;
        });
      }
      return [];
    },

    hasSelectedPackageWithShippingOption(){
      return this.packagesWithShipping.length>0;
    },

    hasSelectedReceiptOption(){
      return this.spendenquittung;
    },

    enableReceiptOption(){
      return this.totalPersonalDonation>=50 && !this.emptyEmail; // || in ineme selected package shipping true ist
    },

    btnDonateButton(){
      return this.isSmallTouchDevice()?"UNTERSTÜTZEN":"JETZT UNTERSTÜTZEN"
    },

    emptyEmail(){
      return this.email.trim()==""|| !this.reg.test(this.email);
    },

    notValid(){
      return (this.totalPersonalDonation<=0|| isNaN(this.totalPersonalDonation) || (this.emailRequired && this._.isEmpty(this.email)) || !this.anonymDonation &&(this.name.trim()=='' || this.emptyEmail)) // || (this.needAdress && this.invalidAdress) //this.email_proof.trim()=='' || this.email.trim()!=this.email_proof.trim()
    }
  },
  methods:{
    filterInput($event){
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if (keyCode!=32 && !(/[0-9a-zA-Z]/i.test($event.key))) { 
        $event.preventDefault();
      }
    },
    scrollToDonateBox() {
    const el = this.$refs.donationList;

    if (el) {
      // Use el.scrollIntoView() to instantly scroll to the element
      el.scrollIntoView({behavior: 'smooth'});
    }
  },
    getCheckedStream(stream_id){
      if(this._.isEmpty(stream_id)){
        let stream=(this.project)?this.getLastStreamByProjectId(this.project.id):null;
        if(!this._.isEmpty(stream)){
          stream_id=stream.id;
        }
      }
     
      return stream_id;
    },
    setForward(){
      if(this.previewData){
        this.previewData=false;
        return
      }

      this.step++;
      if(this.step==3){
        this.initPaypal();
      }

      //Scroll to donation box
      this.$nextTick(()=>{
        this.scrollToDonateBox();
      });
    },
    setBackward(){
      this.step--;
    },
    donationSuccess(){
      this.setForward();
    },
    initPaypal(){
      this.$nextTick(() => {
			if(this.$refs && this.$refs.payments){
        this.$refs.payments.init();
      }
		});
      
    },
    setDonation(index,event){
      if(this.packages && event){
        this.$set(this.packages, index, event.target.value);
        this.calculateDonation();
      }
    },
    calculateFreeDonation(){
      if(this.project.package_free){
        this.totalPersonalDonation=this.packageFreeValue;
        this.initPackages();
      }
    },
    calculateDonation(){
      if(this.project){
        if(this._.isArray(this.project.package)){
          this.totalPersonalDonation=0;
          let index=0;
          this.totalPersonalPackages="";
          let packages=[];
          this._.forEach(this.project.package, (obj)=> {
            if(obj){
              let price=obj.price*this.packages[index];
              this.totalPersonalDonation+=price;
              if(price>0){
                packages.push(obj.name)
              }
            }
            index++;
          });
          this.totalPersonalPackages=packages.join('|');
          this.packageFreeValue=this.totalPersonalDonation;
        }
        
      }
    },
    initPackages(){
        if(this.project && this._.isArray(this.project.package)){
          this.packages=this._.range(0, this.project.package.length, 0);
          return true;
        }
        return false;
    },
    initView(){
      if(!this.initialized){
        if(this.initPackages()){
          this.initialized=true;
        }
      }
    }
  },

  mounted(){
    this.initView();
  },
};
</script>

<style scoped type='text/css'>
.btnBack{
  color:grey!important;
  box-shadow: none;
}

.donationList, .package_additional{
  max-width:600px;
  margin: auto;
  text-align: center;
}

.package_additional{
  width:100%;
  overflow:hidden;
  padding-top:20px;
}

.donationListBox{
		box-shadow: inset 0 0 0 2px #212931;
}

.gsn-donate-button{
  white-space: normal;
  height: auto;
}

 .donationIcon{
    width:80%;
    max-width: 300px;
  }
.donAdd{
  font-size:small;
      font-style: italic;
}
</style>